import Tooltip from 'style-guide/Tooltip';
import CategoriesName from '../CategoriesName';
import CategoriesSection from '../CategoriesSection';
import CategoriesWrapper from '../style/CategoriesWrapper';

const VolumeCategories = ({ activeCategory, changeCategory, options, onClick, isPreview, ...props }) => (
  <CategoriesWrapper className='volume-categories'>
    <div className='filter-categories pl--48'>
      {options.map(({ name, value, disabled }) =>
        disabled ? (
          <Tooltip overlay='Complete "Story" section videos to unlock "Assessment" section' placement='top'>
            <CategoriesSection
              key={value}
              activeCategory={activeCategory}
              value={value}
              changeCategory={changeCategory}
              onClick={onClick}
              disabled={disabled}
              sectionProps={props}
            >
              <CategoriesName activeCategory={activeCategory} value={value}>
                {name}
              </CategoriesName>
            </CategoriesSection>
          </Tooltip>
        ) : (
          <CategoriesSection
            key={value}
            activeCategory={activeCategory}
            value={value}
            changeCategory={changeCategory}
            onClick={onClick}
            disabled={disabled || isPreview}
            sectionProps={props}
          >
            <CategoriesName activeCategory={activeCategory} value={value}>
              {name}
            </CategoriesName>
          </CategoriesSection>
        )
      )}
    </div>
  </CategoriesWrapper>
);

export default VolumeCategories;
